import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './LegalPage.css';

const Privacy = () => {
  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{t.privacy.title}</h1>
        <p className="legal-updated">{t.privacy.lastUpdated}: December 1, 2024</p>
        
        <section>
          <h2>{t.privacy.section1.title}</h2>
          <p>{t.privacy.section1.content}</p>
        </section>

        <section>
          <h2>{t.privacy.section2.title}</h2>
          <p>{t.privacy.section2.content}</p>
        </section>

        <section>
          <h2>{t.privacy.section3.title}</h2>
          <p>{t.privacy.section3.content}</p>
        </section>

        <section>
          <h2>{t.privacy.section4.title}</h2>
          <p>{t.privacy.section4.content}</p>
        </section>

        <section>
          <h2>{t.privacy.contact.title}</h2>
          <p>{t.privacy.contact.content}</p>
          <p><a href="mailto:jinhuqi@agentecfusion.com">jinhuqi@agentecfusion.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
